import React, { useContext, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { HelpModeContext } from "./Contexts";
import Box from "@mui/material/Box";
import DashboardPanelHeader from "./DashboardPanelHeader";
import {
  HtmlEditor,
  Image,
  Inject,
  Link,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar,
} from "@syncfusion/ej2-react-richtexteditor";
import "./styles/DashboardTasks.css";

function DashboardNotes(props) {
  const [displayPage, setDisplayPage] = useState();
  const helpMode = useContext(HelpModeContext).mode;
  const dbConfig = JSON.parse(sessionStorage.getItem("dashboardConfig")) || [];
  const panelInfo = dbConfig.find(
    (elem) => elem.id == "widget_" + props.panelId,
  );
  const panelHeight = panelInfo.sizeY;
  const toolbarSettings = {
    items: [
      "Bold",
      "Italic",
      "Underline",
      "StrikeThrough",
      "|",
      "Formats",
      "Alignments",
      "OrderedList",
      "UnorderedList",
      "Outdent",
      "Indent",
      "|",
      "CreateLink",
      "FullScreen",
      "|",
      "Undo",
      "Redo",
    ],
    type: "Expand",
  };
  useEffect(() => {
    const prepDisplayPage = (
      <>
        <Box
          className="dashTableTitleBar"
          height={12 / panelHeight + "%"}
          id="__dashboardNotes_header"
          sx={{ cursor: helpMode ? "help" : "default" }}
        >
          <DashboardPanelHeader
            panelLocked={props.panelLocked}
            title="Project Notes"
            removePanel={props.removePanel}
            panelId={props.panelId}
            //headerComponent={addLinkComponent}
          />
        </Box>

        <Box
          height="85%"
          id="__dashboardNotes"
          sx={{
            overflow: "auto",
            verticalAlign: "middle",
            border: "solid 2px",
            padding: "0px 4px 4px 4px",
            borderRadius: "0px 0px 6px 6px",
            backgroundColor: "white",
            cursor: helpMode ? "help" : "default",
          }}
        >
          <RichTextEditorComponent
            height="100%"
            toolbarSettings={toolbarSettings}
          >
            <p>foo</p>
            <Inject
              services={[Image, Link, HtmlEditor, QuickToolbar, Toolbar]}
            />
          </RichTextEditorComponent>
        </Box>
      </>
    );
    setDisplayPage(prepDisplayPage);
  }, []);

  return displayPage;
}

export default DashboardNotes;

DashboardNotes.propTypes = {
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
};
